import React, {useMemo, useEffect} from 'react';
import {Table} from 'semantic-ui-react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Filter, DefaultColumnFilter} from '../common/TableFilters';
import TablePaginator from '../common/TablePaginator';
import './styles.scss';

const CommonTable = ({filteredRows, list, columnsTable, handleChange}) => {
  const data = useMemo(() => list, [list]);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    rows,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {
        'pageIndex': 0,
        'pageSize': 10,
        'filters': [
          {
            'id': 'status',
            'value': 'A',
          },
        ],
      },
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    if (rows.length !== filteredRows.length) {
      handleChange('filteredRows', rows);
    }
  }, [rows]);

  return (
    <>
      <div className="table-container container-custom-generic">
        <Table unstackable className="interactive" compact striped {...getTableProps()}>
          <Table.Header className='sticky'>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    className='header-cell-table'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => {
              const headers = headerGroup.headers;
              if (headers.length > 3 && headers[1]?.originalId !== 'exoneracion') {
                return (
                  <Table.Row key="filters" id="filters">
                    {headerGroup.headers.map((column, index) => (
                      <Table.HeaderCell
                        key={`filter-${index}`}
                        className={index === 7 ? 'dropdown-header' : ''}
                        textAlign="center"
                      >
                        <Filter column={column} />
                      </Table.HeaderCell>
                    ))}
                  </Table.Row>
                );
              }
              return null;
            })}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row className="empty-results">
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell className='cell-custom-small' textAlign="center" {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default CommonTable;
